import { useState } from 'react';
import { StyledButton } from '../StyledComponents';
import MyDropzone from '../Dropzone';
import Loading from '../Loading'
import Snackbar from '../Snackbar';

import '../../styles/UploadFile.css';

const server = process.env.REACT_APP_OCR_de_OC_API_URL;

const UploadFileView = ({ setView, file, setFile, setData }) => {
  const [loading, setLoading] = useState(false);
  const [snackbarText, setSnackbarText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const convertFile = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await fetch(`${server}/convertPdf`, {
          method: 'POST',
          body: formData
        });
        if(response.ok) {
          const { structuredData, textResults } = await response.json();
          setData({structuredData, textResults});
          setLoading(false);
          setView("SeeData");
        } else {
          setLoading(false);
          setSnackbarText("Hubo un error al transformar el archivo");
          setOpenSnackbar(true);
        }

      } catch (error) {
        console.error('Error en la conexión con el servidor', error.message);
        setLoading(false);
        setSnackbarText("Hubo un error con la conexión al servidor");
        setOpenSnackbar(true);
      }
      
    } catch (error) {
      console.error('Error con el archivo', error.message);
      setLoading(false);
      setSnackbarText("Hubo un error con el archivo a cargar");
      setOpenSnackbar(true);
    }
  };

  return (
    <div>
      { loading === true ? (
        <div className="loading-container">
          <Loading/>
        </div>
      ) : (
        <div>
          <div className="dropzoneMainContainer">
            <div className="dropzoneContainer">
              <MyDropzone setFile={setFile} file={file} />
            </div>
          </div>

          <div className="convertButtonMainContainer">
            <div className="convertButtonContainer">

              <div className="convertButton">
                {file != null ? (
                  <StyledButton disabled={loading} style={{ fontSize: "18px", border: `4px solid var(--Success-color)` }} onClick={() => convertFile()}>Convertir</StyledButton>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {openSnackbar ? (
              <Snackbar snackbarText={snackbarText} setOpenSnackbar={setOpenSnackbar}></Snackbar>
            ) : (<></>)
          }
        </div>
      )}
    </div>
  )
};

export default UploadFileView